/* eslint-disable @typescript-eslint/no-explicit-any */
import { post, put, get } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import { Bundle } from '_core/util';
import Definitions from '../Definitions';
import {
  AcceptTermsType,
  IMemberAddress,
  MemberEletronicAddressType,
  MinorLegalGuardianType,
  MemberDocumentType,
  MemberPhoneType,
} from '../Types/CommonTypes';

export type MemberCommonTypes = {
  acceptTerms: AcceptTermsType;
  addressList: IMemberAddress[];
  deviceFingerprint?: string;
  electronicAddressList: MemberEletronicAddressType[];
  emailSocialNetwork?: string;
  socialIdNumber?: string;
  socialIdProvider?: string;
};

export interface ICreateMemberRequest extends MemberCommonTypes {
  name: string;
  documentList: MemberDocumentType[];
  phoneList: MemberPhoneType[];
  allowMail: boolean;
  allowSMS: boolean;
  allowPromoEmail: boolean;
  password: string;
  passwordConfirmation: string;
  indicationCode?: string;
  iva?: string;
  recaptcha?: {
    responseToken?: string;
  };
  birthDate: string;
  minorLegalGuardian?: MinorLegalGuardianType;
}

export interface IUpdateMemberRequest extends MemberCommonTypes {
  documentList?: MemberDocumentType[];
  phoneList?: MemberPhoneType[];
  allowMail?: boolean;
  allowSMS?: boolean;
  allowPromoEmail?: boolean;
  geoCode?: string;
  sendAccrualRdmEmail?: string;
  contactType: 'SMS' | 'EMAIL';
}

const definitions = Definitions.Member;

const callPost = async (
  member: ICreateMemberRequest,
): Promise<IFinalResponse> => {
  const smilesToken = Bundle.getValue('smilesToken');

  const init: InitApiType = {
    body: {
      ...member,
      smilesToken,
    },
  };
  return post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};

const callPut = async (
  member: IUpdateMemberRequest,
): Promise<IFinalResponse> => {
  const init: InitApiType = {
    body: {
      ...member,
    },
  };
  return put(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};

const callGet = async (): Promise<IFinalResponse> => {
  return get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    {},
  );
};

const call = { post: callPost, put: callPut, get: callGet };

export default { call, definitions };
